(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdv-home-flow"] && !Shopify.designMode) return;
  try {
    
function initCdvKlo(scope = document) {
  scope.querySelectorAll('[data-cdv-klo]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const video = gallery.querySelector('video');
    if (!video) return;
    const pause = gallery.querySelector('[data-cdv-klo-pause]');
    const mute = gallery.querySelector('[data-cdv-klo-mute]');
    const title = gallery.querySelector('[data-cdv-klo-title]');
    const works = [...gallery.querySelectorAll('[data-cdv-klo-work]')];
    const update = () => {
      const pauseLabel = video.paused ? gallery.dataset.play : gallery.dataset.pause;
      pause.setAttribute('aria-label', pauseLabel);
      pause.setAttribute('title', pauseLabel);
      pause.querySelector('[data-cdv-icon="play"]').toggleAttribute('hidden', !video.paused);
      pause.querySelector('[data-cdv-icon="pause"]').toggleAttribute('hidden', video.paused);
      pause.setAttribute('aria-pressed', String(video.paused));
      const muteLabel = video.muted ? gallery.dataset.unmute : gallery.dataset.mute;
      mute.setAttribute('aria-label', muteLabel);
      mute.setAttribute('title', muteLabel);
      mute.querySelector('[data-cdv-icon="muted"]').toggleAttribute('hidden', !video.muted);
      mute.querySelector('[data-cdv-icon="sound"]').toggleAttribute('hidden', video.muted);
      mute.setAttribute('aria-pressed', String(!video.muted));
    };
    const selected = works.find(work => work.getAttribute('aria-pressed') === 'true');
    if (selected) title.textContent = selected.dataset.title;
    video.controls = false;
    video.playsInline = true;
    video.muted = true;
    video.loop = false;
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('volumechange', update);
    pause.addEventListener('click', () => video.paused ? video.play().catch(update) : video.pause());
    mute.addEventListener('click', () => { video.muted = !video.muted; update(); });
    works.forEach(work => work.addEventListener('click', () => {
      video.pause();
      video.querySelectorAll('source').forEach(source => source.remove());
      video.src = work.dataset.src;
      video.poster = work.dataset.poster;
      video.load();
      works.forEach(button => button.setAttribute('aria-pressed', String(button === work)));
      title.textContent = work.dataset.title;
      video.play().catch(update);
      update();
    }));
    video.addEventListener('ended', () => {
      if (!works.length) return;
      const index = works.findIndex(work => work.getAttribute('aria-pressed') === 'true');
      works[(index + 1) % works.length].click();
    });
    gallery.addEventListener('shopify:block:select', event => {
      const work = event.target.closest('[data-cdv-klo-work]');
      if (work) work.click();
    });
    video.play().catch(update);
    update();
  });
}
initCdvKlo();
document.addEventListener('shopify:section:load', event => initCdvKlo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-home"] && !Shopify.designMode) return;
  try {
    
function initCdvKlo(scope = document) {
  scope.querySelectorAll('[data-cdv-klo]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const video = gallery.querySelector('video');
    if (!video) return;
    const pause = gallery.querySelector('[data-cdv-klo-pause]');
    const mute = gallery.querySelector('[data-cdv-klo-mute]');
    const title = gallery.querySelector('[data-cdv-klo-title]');
    const works = [...gallery.querySelectorAll('[data-cdv-klo-work]')];
    const update = () => {
      const pauseLabel = video.paused ? gallery.dataset.play : gallery.dataset.pause;
      pause.setAttribute('aria-label', pauseLabel);
      pause.setAttribute('title', pauseLabel);
      pause.querySelector('[data-cdv-icon="play"]').toggleAttribute('hidden', !video.paused);
      pause.querySelector('[data-cdv-icon="pause"]').toggleAttribute('hidden', video.paused);
      pause.setAttribute('aria-pressed', String(video.paused));
      const muteLabel = video.muted ? gallery.dataset.unmute : gallery.dataset.mute;
      mute.setAttribute('aria-label', muteLabel);
      mute.setAttribute('title', muteLabel);
      mute.querySelector('[data-cdv-icon="muted"]').toggleAttribute('hidden', !video.muted);
      mute.querySelector('[data-cdv-icon="sound"]').toggleAttribute('hidden', video.muted);
      mute.setAttribute('aria-pressed', String(!video.muted));
    };
    const selected = works.find(work => work.getAttribute('aria-pressed') === 'true');
    if (selected) title.textContent = selected.dataset.title;
    video.controls = false;
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('volumechange', update);
    pause.addEventListener('click', () => video.paused ? video.play().catch(update) : video.pause());
    mute.addEventListener('click', () => { video.muted = !video.muted; update(); });
    works.forEach(work => work.addEventListener('click', () => {
      video.pause();
      video.querySelectorAll('source').forEach(source => source.remove());
      video.src = work.dataset.src;
      video.poster = work.dataset.poster;
      video.load();
      works.forEach(button => button.setAttribute('aria-pressed', String(button === work)));
      title.textContent = work.dataset.title;
      video.play().catch(update);
      update();
    }));
    gallery.addEventListener('shopify:block:select', event => {
      const work = event.target.closest('[data-cdv-klo-work]');
      if (work) work.click();
    });
    video.play().catch(update);
    update();
  });
}
initCdvKlo();
document.addEventListener('shopify:section:load', event => initCdvKlo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-navigation"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
 const teaser = document.querySelector("[data-cdv-text-teaser]");
 const hero = document.querySelector(".cdv-hero");
 if (teaser && hero) hero.after(teaser);
 document.querySelectorAll('.cdv-grid:not(.cdv-creations-grid)').forEach(track => {
  const controls = document.createElement('div'); controls.className = 'cdv-warm-controls';
  [-1,1].forEach(direction => {
   const button = document.createElement('button'); button.type = 'button'; button.textContent = direction < 0 ? '←' : '→'; button.setAttribute('aria-label', direction < 0 ? '←' : '→');
   button.addEventListener('click', () => { const card = track.querySelector('.cdv-card'); track.scrollBy({left: direction * (card.getBoundingClientRect().width + 24), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }); controls.append(button);
  }); track.before(controls);
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdv-page"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cdv-display-gallery]').forEach(gallery=>{const track=gallery.querySelector('.cdv-display-track');function move(direction){const slide=track.querySelector('figure');if(!slide)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(slide.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}gallery.querySelector('[data-cdv-gallery-prev]').addEventListener('click',()=>move(-1));gallery.querySelector('[data-cdv-gallery-next]').addEventListener('click',()=>move(1));track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}});});
document.querySelectorAll('[data-cdv-store]').forEach(store=>{const dialog=store.querySelector('.cdv-store-lightbox');if(!dialog||!dialog.showModal)return;const image=dialog.querySelector('img');const caption=dialog.querySelector('p');let trigger;store.querySelectorAll('[data-cdv-store-zoom]').forEach(link=>link.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();trigger=link;image.src=link.href;image.alt=link.querySelector('img').alt;caption.textContent=image.alt;dialog.showModal();}));dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});dialog.addEventListener('close',()=>{image.removeAttribute('src');if(trigger)trigger.focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
